// @ts-nocheck





import { fetchRequest } from './index';
import { convertFromKmToM, convertFromMToKm } from '../pure/unitConversions';

const convertDataFromServer = (route) => ({
  ...route,
  distance: convertFromMToKm(route.distance)
});
const convertDataToServer = (route) => ({
  ...route,
  distance: convertFromKmToM(route.distance)
});

export const fetchRoute = async (
id,
params = {}) =>
{
  const route = await fetchRequest.get(`/route/${id}`, params);
  if (route) return convertDataFromServer(route);
  throw new Error('Не удалось загрузить маршрут');
};

export const deleteRoute = async (id) => {
  const route = await fetchRequest.delete(`/route/${id}`);
  if (route) return convertDataFromServer(route);
  throw new Error('Не удалось удалить маршрут');
};

export const cloneRoute = async (id) => {
  const route = await fetchRequest.post(`/route/${id}/clone`);
  if (route) return convertDataFromServer(route);
  throw new Error('Не удалось склонировать маршрут');
};

export const addRoute = async (route) => {
  const added = await fetchRequest.post('/route', convertDataToServer(route));
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать маршрут');
};

export const updateRoute = async (route) => {
  const updated = await fetchRequest.put('/route', convertDataToServer(route));
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить маршрут');
};

export default {
  addRoute,
  updateRoute,
  fetchRoute,
  deleteRoute,
  cloneRoute
};
